export default function creditsafeCompanySearchInput() {
	const searchBarCreditsafeInput = document.getElementById(
		'searchBarCreditsafe',
	);
	const errorMessageElement = document.getElementById('errorMessageElement');
	const submitButton = document.getElementById('submitCompanySearchButton');

	function debounce(func, delay) {
		let timeoutId;
		return function (...args) {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}
	const foundCompanyContainer = document.getElementById(
		'foundCompanyContainer',
	);
	const foundCompanyContainerItemsElem = document.getElementById(
		'foundCompanyContainerItems',
	);

	let companiesList;

	foundCompanyContainer.addEventListener(
		'click',
		handleBillingAddressFormClick,
	);

	function renderCompaniesList(companies) {
		companiesList = companies;
		if (companiesList.length === 1)
			showBillingAddressForm(companiesList[0].creditCheckedCompanyId);
		let companiesListString = '';
		companies.forEach(company => {
			companiesListString += buildCompanyItem(company);
		});
		foundCompanyContainerItemsElem.innerHTML = companiesListString;

		foundCompanyContainer.toggleAttribute('hidden', !companies.length);
	}

	function handleBillingAddressFormClick({ target }) {
		const { creditCheckedCompanyId } = target.closest(
			'[data-credit-checked-company-id]',
		).dataset;
		showBillingAddressForm(creditCheckedCompanyId);
	}

	function showBillingAddressForm(creditCheckedCompanyId) {
		if (!creditCheckedCompanyId) return;

		const selectedCompany = companiesList.find(
			company => company.creditCheckedCompanyId === creditCheckedCompanyId,
		);
		const creditsafeCompanySearchForm = document.getElementById(
			'creditsafeCompanySearchForm',
		);
		const showBillingAddressFormEvent = new CustomEvent(
			'show-billing-address-form',
			{ detail: selectedCompany },
		);
		creditsafeCompanySearchForm.dispatchEvent(showBillingAddressFormEvent);
	}

	function buildCompanyItem({
		companyName,
		postalCode,
		town,
		streetNumber,
		streetName,
		chamberOfCommerceId,
		creditCheckedCompanyId,
	}) {
		const streetInfo = streetNumber
			? `${streetName}, ${streetNumber}`
			: streetName;
		const chamberInfo = chamberOfCommerceId ?? '';
		const chamberInfoText = chamberInfo ? `, ${chamberInfo}` : '';
		const companyItem = `<p data-credit-checked-company-id="${creditCheckedCompanyId}" class="creditsafe-company-search__company-item">${companyName}${chamberInfoText} ${streetInfo}, ${town}, ${postalCode}</p>`;
		return companyItem;
	}
	const radioButtonsContainer = document.getElementById(
		'radioButtonsContainer',
	);
	const radioButtons = radioButtonsContainer.querySelectorAll('input');

	function hideFoundCompanies() {
		foundCompanyContainer.setAttribute('hidden', '');
	}
	function searchCompany({ searchTerm, searchBy }) {
		fetch(
			`ajax/creditsafe/company/search?searchBy=${searchBy}&searchTerm=${encodeURIComponent(searchTerm)}`,
		)
			.then(response => response.json())
			.then(response => {
				if (response.status === 'ERROR') {
					hideFoundCompanies();
					errorMessageElement.textContent = response.message;
				} else {
					const { companies = [] } = response.data;
					if (companies.length) {
						errorMessageElement.textContent = '';
						renderCompaniesList(companies);
					}
				}
			})
			.catch(() => {
				errorMessageElement.textContent =
					'We couldn\'t find this company due to a technical issue. Please select "Enter billing details manually”.';
				hideFoundCompanies();
			});
	}
	function onSubmit(event) {
		event.preventDefault();
		const value = getValue();
		searchCompany(value);
	}
	function onInput(event) {
		event.preventDefault();
		const value = getValue();
		if (value.searchBy === 'NUMBER') return;
		searchCompany(value);
	}
	function getValue() {
		const searchTerm = searchBarCreditsafeInput.value;
		if (!searchTerm) {
			hideFoundCompanies();
			return;
		}
		const { value: searchBy } = [...radioButtons]?.find(
			radioButton => radioButton.checked,
		);
		return { searchTerm, searchBy: searchBy.toUpperCase() };
	}

	submitButton.addEventListener('click', onSubmit);

	searchBarCreditsafeInput.addEventListener('input', debounce(onInput, 1000));
}
